import { createContext, useContext } from "react";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { useUserStatus } from "@hooks/useUserStatus";

/** The user and organization LaunchDarkly last finished identifying. */
export interface FeatureFlagsIdentity {
    userId: number;
    organizationId: string | null;
}

export const FeatureFlagsIdentityContext =
    createContext<FeatureFlagsIdentity | null>(null);

/**
 * Whether the feature flags are the current user's and organization's. Until
 * then LaunchDarkly serves an anonymous context's values, so a targeted flag
 * reads off.
 */
export function useHasIdentifiedFeatureFlags(): boolean {
    const identity = useContext(FeatureFlagsIdentityContext);
    const { data: userStatus } = useUserStatus();
    const activeOrganization = useActiveOrganization();

    return (
        identity !== null &&
        identity.userId === userStatus?.user.id &&
        identity.organizationId === (activeOrganization?.id ?? null)
    );
}
